import { twMerge } from "tailwind-merge";

const COLORS = {
    primary:
        "text-white bg-gray-600 hover:bg-gray-700 shadow shadow-gray-500/15",
    secondary:
        "text-gray-700 bg-gray-200 hover:bg-gray-300 border border-gray-300 shadow shadow-gray-400/20",
    tertiary:
        "text-[#051A2E] bg-transparent border border-gray-300 hover:border-gray-400 hover:bg-gray-50/50",
    reset: "text-neutral-100 bg-red-500 hover:bg-red-500/75",
};

const SIZES = {
    small: "text-xs py-1.5 px-2 font-normal",
    medium: "text-sm py-2 px-3 font-normal",
    large: "text-base py-2 px-4 font-normal",
};

export interface ButtonProps {
    children?: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    type?: "primary" | "secondary" | "tertiary" | "reset";
    size?: "small" | "medium" | "large";
    className?: string;
}

export function Button(props: ButtonProps) {
    const { children, onClick, disabled, type, className, size } = props;
    let color: ButtonProps["type"] = "primary";
    if (type) color = type;
    let size_: ButtonProps["size"] = "medium";
    if (size) size_ = size;
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={twMerge(
                "font-normal rounded-xl h-fit cursor-pointer",
                COLORS[color],
                size_ && SIZES[size_],
                className
            )}
        >
            {children}
        </button>
    );
}

export default Button;
